<script lang="ts" setup>
import MainSnackbarQueue from "@/application/components/MainSnackbarQueue.vue";
import { useAppTheme } from "@/application/composables/appTheme";
import { useMetaStore } from "@/application/stores/meta";
import { AppIdentifier } from "@/application/enums";
import { useApp } from "@/application/composables/app";
import { useAuthStore } from "@/application/stores/authStore";
import { useCheckForOnboarding } from "@/modules/tenantAdmin/onboarding/composables/checkForOnboarding";
import { whenever } from "@vueuse/core";
import { useRoute } from "vue-router";
import { watch } from "vue";

const metaStore = useMetaStore();
const authStore = useAuthStore();
const { setPageTitle } = useAppTheme();
const { appIdentifier } = useApp();
const { action } = useCheckForOnboarding();
const route = useRoute();

const configureApp = async () => {
  if (
    appIdentifier === AppIdentifier.TenantAdmin ||
    appIdentifier === AppIdentifier.CentralAdmin
  ) {
    authStore.updateProfileIfOutdated();
  }

  if (
    appIdentifier === AppIdentifier.TenantAdmin ||
    appIdentifier === AppIdentifier.TenantWebsite
  ) {
    await metaStore.fetch();
  }

  setPageTitle();
};

whenever(
  () =>
    authStore.isLoggedIn ||
    appIdentifier === AppIdentifier.TenantWebsite ||
    appIdentifier === AppIdentifier.CentralWebsite,
  configureApp,
  {
    immediate: true,
  },
);

watch(
  () =>
    metaStore.meta &&
    authStore.profile &&
    appIdentifier === AppIdentifier.TenantAdmin &&
    route.name &&
    !String(route.name).includes("auth."),
  (newValue) => {
    if (newValue) action();
  },
);
</script>

<template>
  <VApp>
    <RouterView />

    <MainSnackbarQueue />
  </VApp>
</template>
